import { defineComponent as g, mergeModels as y, useModel as B, computed as o, provide as M, ref as I, createElementBlock as S, openBlock as v, mergeProps as b, unref as i, renderSlot as k } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list.js";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list-grid.js";
import { useOUIAProps as L } from "../../helpers/ouia.js";
const w = Symbol("DataListSelectableKey"), U = /* @__PURE__ */ g({
  name: "PfDataList",
  __name: "DataList",
  props: /* @__PURE__ */ y({
    selectionInputName: {},
    selectionInputValue: {},
    selectionMultiple: { type: Boolean },
    compact: { type: Boolean },
    expandable: { type: Boolean, default: void 0 },
    gridBreakpoint: { default: "md" },
    wrapModifier: {},
    "onUpdate:selected": {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    selected: {},
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(l, { emit: d }) {
    const n = {
      none: t.modifiers.gridNone,
      always: "pf-m-grid",
      // Placeholder per https://github.com/patternfly/patternfly-react/issues/4965#issuecomment-704984236
      sm: t.modifiers.gridSm,
      md: t.modifiers.gridMd,
      lg: t.modifiers.gridLg,
      xl: t.modifiers.gridXl,
      "2xl": t.modifiers.grid_2xl
    }, e = l, p = L({ id: e.ouiaId, safe: e.ouiaSafe }), m = d, r = B(l, "selected"), c = o(() => !!e["onUpdate:selected"] || r.value !== void 0 || !!e.selectionInputName);
    M(w, {
      emit: m,
      selectable: c,
      expandable: o(() => e.expandable),
      inputName: o(() => e.selectionInputName),
      inputValue: o(() => e.selectionInputValue),
      itemSelection: r,
      multipleSelection: o(() => e.selectionMultiple)
    });
    const u = o(() => n[e.gridBreakpoint]), f = I(!1);
    return (a, N) => (v(), S("ul", b(i(p), {
      class: [
        i(s).dataList,
        u.value,
        {
          [i(s).modifiers.compact]: a.compact,
          [i(s).modifiers[a.wrapModifier ?? "nowrap"]]: a.wrapModifier,
          [i(s).modifiers.dragOver]: f.value
        }
      ]
    }), [
      k(a.$slots, "default")
    ], 16));
  }
});
export {
  w as DataListKey,
  U as default
};
